import styled from 'styled-components';

interface Props {
  open: boolean;
}

export const Container = styled.div<Props>`
  height: 64px;
  min-height: 64px;
  display: flex;
  align-items: center; 
  align-self: flex-start;

  padding-inline: ${props => (props.open ? '10px' : '0px')};

  > div {
    width: 100%;
    overflow: hidden;
  }
  transition: 800ms;
`;

export const HamburgerButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 200ms ease;
  
  &:hover {
    background-color: rgba(116, 76, 180, 0.1);
  }
`;
